import axios from "axios";
import config from "./config";

const env = process.env.NODE_ENV || "development";
const stage = config[env];
const API_URL = stage.base_url + "/review";

const create = (reviewData, title, body, stars, jwt) => {
  const headers = { Authorization: "bearer " + jwt };
  return axios.post(
    API_URL + "/create",
    {
      title,
      body,
      stars,
      reviewee_type: reviewData.reviewee_type,
      reviewee_id: reviewData.reviewee_id,
      reviewer_id: reviewData.reviewer_id,
    },
    { headers: headers }
  );
};

const list = (reviewee_id, reviewee_type) => {
  return axios.get(
    API_URL + `/list?reviewee_id=${reviewee_id}&reviewee_type=${reviewee_type}`
  );
};

// const getCurrentUser = () => {
//   return JSON.parse(localStorage.getItem("user"));
// };

export default {
  create,
  list,
};
